import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Numeral from "react-numeral";
import { HttpRequest } from "../../../services/httpRequest";
import { conveniosRecaudoExtend } from "../../../utils/conveniosRecaudo";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import moment from "moment";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import "../../../index.css";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";

export function CashPayPageExtend() {
  const { disclosures, creditInfo, due } = useCredit();
  let navigate = useNavigate();
  const [basicInfo, setBasicInfo] = useState({});
  const [creditsInfo, setCreditsInfo] = useState([]);
  const [userInfoAuth, setUserInfoAuth] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [deudaAFecha, setDeudaAFecha] = useState(0);
  const [costs, setCosts] = useState([]);
  const [deudaSinCapital, setDeudaSinCapital] = useState(0);

  const loadCredits = async () => {
    try {
      const data = await HttpRequest.getAllCreditUser(
        localStorage.getItem("doc")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUserAuth = async () => {
    try {
      const data = await HttpRequest.getUserAuth(localStorage.getItem("doc"));
      return data.message.user;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoQuota = async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const configData = async (credit, infoCupo) => {
    let costsFeatures;
    let infoDeudaBackend;
    let deudahoy;
    let deudaSinCapital = 0;
    try {
      let versionTarifas = credit?.versionTarifas;
      let responseData = versionTarifas === "2" ? await HttpRequest.calcularDeudaV2({ credit: credit, infoCupo: infoCupo, }) :
        await HttpRequest.calcularDeuda({ credit: credit, infoCupo: infoCupo, });
      //let responseData = await HttpRequest.calcularDeudaV2({ credit, infoCupo });
      infoDeudaBackend = responseData.message.deuda;
      costsFeatures = infoDeudaBackend?.costsFeature;
      let costs = costsFeatures.filter(
        (feature) => feature?.item !== "Saldo a capital"
      );
      let total = 0;
      for (let i = 0; i < costs.length; i++) {
        let item = costs[i];
        if (item.item === "DCTO firma electrónica" || item.item === "DCTO recompensa") {
          total -= item.value;
        } else {
          total += costs[i].value;
        }
      }
      deudaSinCapital = total;
      deudahoy = infoDeudaBackend?.deudaAFecha;
    } catch (error) {
      console.log(error);
    }
    setDeudaSinCapital(deudaSinCapital);
    setDeudaAFecha(deudahoy);
    setCosts(costsFeatures);
    return;
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadCreditsUser = async () => {
      let credits = await loadCredits();
      return credits;
    };

    const loadQuotaStatus = async () => {
      let quotaStatus = await loadInfoQuota();
      return quotaStatus;
    };

    const loadUserAuth = async () => {
      let userAuth = await loadInfoUserAuth();
      return userAuth;
    };

    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    const determinaCreditoAMostrar = (credits = []) => {
      let vigente = credits.filter((credit) => credit.status === "Vigente");
      let cancelado = credits.filter((credit) => credit.status === "Cancelado");
      let enMora = credits.filter((credit) => credit.status === "En mora");
      let pendienteFirma = credits.filter(
        (credit) => credit.status === "Pendiente de firmar"
      );
      let solRechazada = credits.filter(
        (credit) => credit.status === "Solicitud rechazada"
      );
      let sinEstado = credits.filter((credit) => credit.status === "");

      if (vigente.length > 0) {
        return vigente;
      } else if (cancelado.length > 0) {
        return cancelado;
      } else if (enMora.length > 0) {
        return enMora;
      } else if (pendienteFirma.length > 0) {
        return pendienteFirma;
      } else if (solRechazada.length > 0) {
        return solRechazada;
      } else if (sinEstado.length > 0) {
        return sinEstado;
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        let credit;
        let info;
        let userAuth;
        if (isValidToken) {
          try {
            userAuth = await loadUserAuth();
            info = await loadInfo();
            setBasicInfo(info);
            setUserInfoAuth(userAuth);
            let cupo = await loadQuotaStatus();
            let creditData = await loadCreditsUser();
            if (creditData.length === 0) {
              alert("No tienes creditos activos.");
            } else {
              credit = determinaCreditoAMostrar(creditData);
              if (credit[0].status !== "Cancelado") {
                //determinarMora(credit[0].acceptanceDate, credit[0].termInDays);
              } else if (credit[0].status === "Solicitud rechazada") {
                console.log("Credito denegado");
              }
              configData(credit[0], cupo);
              setCreditsInfo(credit);
            }
            setIsLoading(false);
          } catch (error) {
            console.log(error);
            returnToSignin(navigate);
          }
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"2"}
          title={"Recibo de pago"}
          disclosures={disclosures}
          creditInfo={creditInfo}
          due={due}
          main={
            <>
              <div className="py-10">
                <div className="mx-8 xl:mx-16 px-8 py-10 bg-white shadow-lg rounded-md">
                  <div className="md:flex text-center md:text-auto">
                    <div className="mx-auto md:mx-0 w-8 h-8">
                      <SkeletonDahsboard
                        variant={"circular"}
                        height={30}
                        width={30}
                      />
                    </div>
                    <h3 className="flex justify-center font-bold text-xl">
                      <SkeletonDahsboard height={30} width={180} />
                    </h3>
                  </div>
                  <div className="px-4 py-4">
                    <div className="pb-4">
                      <span>
                        <SkeletonDahsboard height={25} width={180} />
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="mr-2">
                        <SkeletonDahsboard height={20} width={80} />{" "}
                      </span>
                      <span>
                        <SkeletonDahsboard height={20} width={60} />
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="mr-2">
                        <SkeletonDahsboard height={20} width={80} />{" "}
                      </span>
                      <span>
                        <SkeletonDahsboard height={20} width={110} />
                      </span>
                    </div>
                  </div>
                  <div className="px-4">
                    <div className="flex text-xl font-bold justify-between pt-4">
                      <span>
                        <SkeletonDahsboard height={30} width={120} />
                      </span>
                      <SkeletonDahsboard height={30} width={80} />
                    </div>
                    <div className="flex justify-between">
                      <span>
                        <SkeletonDahsboard height={20} width={130} />
                      </span>
                      <span>
                        <SkeletonDahsboard height={20} width={80} />
                      </span>
                    </div>
                    <div className="text-purple text-sm pt-4">
                      <span>
                        <span>
                          <SkeletonDahsboard height={20} width={250} />
                        </span>
                        <span>
                          <SkeletonDahsboard height={20} width={240} />
                        </span>
                        <span>
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  const hoy = moment().format("DD/MM/YYYY");

  return (
    <DashboardMyCredit
      name={basicInfo.firstname}
      balance={creditsInfo[0].status === "Cancelado" ? 0 : deudaAFecha}
      current={"2"}
      title={"Recibo de pago"}
      main={
        <>
          {creditsInfo[0].status === "Cancelado" ? (
            <div className="py-10">
              <h2>Esta al dia con su credito</h2>
            </div>
          ) : creditsInfo[0].status === "Solicitud rechazada" ? (
            <div className="py-10">
              <h2>No tiene una deuda activa.</h2>
            </div>
          ) : (
            <div className="py-10">
              <div className="mx-2 md:mx-8 xl:mx-16 px-8 py-10 bg-white shadow-lg rounded-md">
                <div className="md:flex text-center md:text-auto">
                  <img
                    className="mx-auto md:mx-0 w-8 h-8"
                    src="/png/bancolombia.png"
                    alt="bancolombia-galilea"
                  />
                  <h3 className="font-bold text-xl px-4">
                    Corresponsal Bancolombia
                  </h3>
                </div>
                <div className="px-4 py-4">
                  <div className="pb-4">
                    <span>GRUPO EMPRESARIAL ANA SAS</span>
                  </div>
                  {conveniosRecaudoExtend.map((convenio) => (
                    <div className="flex justify-between">
                      <span className="mr-2">{convenio.item} </span>
                      <span>{convenio.value} </span>
                    </div>
                  ))}
                </div>
                <div className="px-4 border-t-2 border-purple">
                  <div className="flex text-xl font-bold justify-between pt-4">
                    <span>Total a pagar</span>
                    <Numeral format={"$0,0"} value={deudaSinCapital} />
                  </div>
                  <div className="flex justify-between">
                    <span>Fecha de vencimiento</span>
                    <span>{hoy}</span>
                  </div>
                  <div className="text-purple text-sm pt-4">
                    <span>
                      Toma una captura de pantalla de este recibo y acércate al
                      corresponsal Bancolombia más cercano.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      }
    />
  );
}
